import React, { useState } from 'react';
// { useState } from 'react';
import './Signin.css';
import logoicon from '../../images/logo-icon.svg';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import logolight from '../../images/urology-logo-white.svg';
import urologylogotransparent from '../../images/urology-logo-transparent.png';
import mailiconbtn from '../../images/mailicon-btn.svg';
import phoneicon from '../../images/phnicon-btn.svg';
import { Link, useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import AuthService from '../services/authservice';
import { useDispatch } from "react-redux";
import { userlogin } from './loginSlice';
import { useFormik } from 'formik';
import { formiksignin } from './validation';
import { toast } from 'react-toastify';

import { MdVisibilityOff, MdVisibility } from "react-icons/md";
import { getRoleHomePath } from '../../utils/roleRoutes';


function SigninComponent() {
  const navigate = useNavigate();

  // state to hold the current value // currently we are using formik so no need to use this
  // const [input, setInput] = useState({
  //   email: "",
  //   password: "",
  // });


  const [modalShow, setModalShow] = React.useState(false);


  const dispatch = useDispatch();


  // code formik : start
  const formik = useFormik({
    ...formiksignin,
    onSubmit: async (values, { setSubmitting }) => {
      try {

        const postData = {
          userInput: values.email,
          password: values.password
        }

        const res = await AuthService.login(postData);

        if (res.data.status === 'SUCCESS') {
          // Ye portal sirf admin/provider ke liye hai. Auth-service PATIENT ka
          // login bhi accept kar leta hai (mobile app wahi endpoint use karta hai),
          // isliye yahan role check karke rok dete hain -- warna user ko login ke
          // baad /unauthorized par phenk diya jaata tha.
          const homePath = getRoleHomePath(res.data.data.role);
          if (!homePath) {
            // AuthService.login localStorage me "user" likh chuka hai -- saaf karo
            AuthService.logout();
            toast.error("This portal is for administrators and providers only.");
            setSubmitting(false);
            return;
          }

          const userObj = {
            _id: res?.data.data._id,
            accessToken: res?.data.data.accessToken,
            email: res?.data.data.email,
            active: res?.data.data.active,
            firstName: res?.data.data.firstName,
            lastName: res?.data.data.lastName,
            role: res?.data.data.role,
            isBlockedFromCommunity: res?.data.data.isBlockedFromCommunity


          };

          dispatch(userlogin(userObj));
          toast.success(res.data.message);

          navigate(homePath, { replace: true })

          setSubmitting(false)

        } else {
          toast.error(res.data.message);
        }

      } catch (error) {
        console.error("API Error:", error);
        toast.error("Login Failed!");
        setSubmitting(false)
      }
    },
  });

  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => setShowPassword((prev) => !prev);


  // code formik : end

  /*--------@ For handle submit for login form----------- */


  return (
    <>
      <section className='signin-blk'>
        <div className='bg-blk'>
          <div className='logo-top'>
            <img src={urologylogotransparent} alt='logo'></img>
          </div>
        </div>
        <div className='signin-text-blk'>
          <div className='signin-content'>
            <div className='logoicon'>
              <img src={logoicon} alt='logo'></img>
            </div>
            <div className='signin-main-text'>
              <h2>Hello Again!</h2>
              <h4>Sign In</h4>
              <p>Enter your email and password for signing in.</p>
              <Form onSubmit={formik.handleSubmit} role="form" >
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Label className='formcontrol-info'>Email Address</Form.Label>
                  <Form.Control type="email" placeholder="Enter Email Address" name="email"
                    value={formik.values.email}
                    onChange={(e) => formik.setFieldValue("email", e.target.value)}
                    className='form-inputs'
                    onBlur={formik.handleBlur}
                    isInvalid={formik.touched.email && !!formik.errors.email}
                  />
                  {formik.touched.email && formik.errors.email ? (
                    <div className="text-danger">{formik.errors.email}</div>
                  ) : null}
                </Form.Group>
                <Form.Group className="mb-3" controlId="formPlaintextPassword">
                  <Form.Label className='formcontrol-info'>Password</Form.Label>

                  <div className="position-relative">
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      placeholder="Password"
                      className="form-inputs pe-5" // add padding-end so text doesn't overlap the icon
                      name="password"
                      value={formik.values.password}
                      onChange={(e) => formik.setFieldValue("password", e.target.value)}
                      onBlur={formik.handleBlur}
                    // isInvalid={formik.touched.password && !!formik.errors.password}
                    />

                    <div
                      onClick={togglePasswordVisibility}
                      className="password-icon"
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: "15px",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        zIndex: 10,
                      }}
                    >
                      {showPassword ? <MdVisibility /> : <MdVisibilityOff />}
                    </div>
                  </div>

                  {formik.touched.password && formik.errors.password && (
                    <div className="text-danger">{formik.errors.password}</div>
                  )}
                </Form.Group>


                <div className='check-blk d-flex justify-content-between'>
                  <div className='keepme-blk'>

                    {/* <Form.Check
                                type="checkbox"
                                id="custom-checkbox"
                                label="Keep me signed in"
                            /> */}

                  </div>
                  <div className='forgot-blk justify-content-end'>
                    <Link to="/forgotpassword">Forgot Your Password</Link>
                  </div>
                </div>
                <Button type="submit" className='dark-btn signin-btn' disabled={formik.isSubmitting} > {formik.isSubmitting ? "Signing" : "Sign In"}</Button>
                <p>New member? <span><Link to="/signup"> Sign up</Link></span></p>
              </Form>
            </div>
          </div>
        </div>
      </section>

      <Modal
        //   {...props}
        show={modalShow}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setModalShow(false)}
      >
        {/* <Modal.Header >
            <Modal.Title id="contained-modal-title-vcenter">
            Two factor authentication 
            </Modal.Title>
          </Modal.Header> */}
        <Modal.Body>
          <h4>Two factor authentication </h4>
          <p>For your security, choose how to receive your verification <br /> code: via mobile number or email.</p>
          <div className='authentication-btns d-flex justify-content-between'>
            <Button variant="primary" className='basic-btn'>
              <img src={phoneicon} alt='icon'></img>
              Mobile Number
            </Button>
            <Button variant="primary" className='basic-btn'>
              <img src={mailiconbtn} alt='icon'></img>
              Email Address
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default SigninComponent;